import { render, staticRenderFns } from "./PurchaseQueue.vue?vue&type=template&id=c9d810c8&scoped=true"
import script from "./PurchaseQueue.vue?vue&type=script&lang=js"
export * from "./PurchaseQueue.vue?vue&type=script&lang=js"
import style0 from "./PurchaseQueue.vue?vue&type=style&index=0&id=c9d810c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d810c8",
  null
  
)

export default component.exports